import { connect, Dispatch } from 'react-redux';
import { OptionsViewModel } from '@models/common.models';
import { AppState, history } from 'src';
import { ServiceFeePaymentComponent, ServiceFeePaymentComponentProperties } from './service-fee-payment.component';

import {
  saveServiceWorkOrderPaymentInfo,
  assignVendorAfterPayment
} from 'src/service-work-order/service-work-order.actions';
import { toggleModal } from '@common/components/common.actions';
import { ServiceWorkOrderCompleteComponent } from './service-work-order-complete.component';
import { RouteDefinitions, getRoute } from '@common/route-definitions';
import { ModalProps } from '@common/components';
import { ServiceWorkOrderViewModel } from '@models/ServiceWorkOrder';
import { getPaymentSwo, getSavedCreditCardsForSwo, SetPaymentSwoAction } from 'src/payment/payment.actions';
import { SwoPaymentViewModel } from '@models/ServiceWorkOrder';

export interface PaymentProperties {}

// This is used to translate the state of the page to the props on the component
function mapStateToProps(state: AppState): Partial<ServiceFeePaymentComponentProperties> {
  return {
    affiliatedAccounts:
      state.contract && state.contract.contractDetailsVM && state.contract.contractDetailsVM.buyer
        ? [
            {
              id: state.contract.contractDetailsVM.buyer.accountId!,
              value: `Buyer: ${state.contract.contractDetailsVM.buyer.name || ''}`
            }
          ]
        : undefined,
    contractEndDate: state.contract.contractDetailsVM ? state.contract.contractDetailsVM!.termEnd : ({} as Date),
    savedCreditCards: state.payment.savedCreditCards,
    serviceWorkOrderVM: state.payment.paymentSwo ? state.payment.paymentSwo : ({} as ServiceWorkOrderViewModel)
  };
}

// This should create proxy wrappers for actions used by the component
function mapDispatchToProps(dispatch: Dispatch<AppState>): Partial<ServiceFeePaymentComponentProperties> {
  return {
    initialize: async (swoId: number) => {
      const setPaymentSwoAction: SetPaymentSwoAction | undefined = await dispatch(getPaymentSwo(swoId));
      if (setPaymentSwoAction) {
        dispatch(getSavedCreditCardsForSwo());
        if (setPaymentSwoAction.swoVM.serviceFeeBalance <= 0) {
          history.push(getRoute(RouteDefinitions.serviceworkorder.Details, { id: setPaymentSwoAction.swoVM.id }));
        }
      }
    },
    submit: (
      swoVM: ServiceWorkOrderViewModel,
      payment: SwoPaymentViewModel,
      firstBilling?: OptionsViewModel,
      laterBills?: OptionsViewModel
    ) => {
      dispatch(
        saveServiceWorkOrderPaymentInfo(
          swoVM.id,
          payment,
          () => {
            dispatch(assignVendorAfterPayment(swoVM.id, swoVM.vendorId));
            dispatch(
              toggleModal({
                title: 'The Service Work Order has been completed!',
                component: ServiceWorkOrderCompleteComponent,
                childProps: {
                  serviceWorkOrderId: swoVM.id
                },
                closeLabel: 'Close',
                closeCallback: () => {
                  history.push(getRoute(RouteDefinitions.serviceworkorder.Details, { id: swoVM.id }));
                },
                saveLabel: 'View Service Work Order Details',
                saveCallback: () => {
                  dispatch(toggleModal());
                  history.push(getRoute(RouteDefinitions.serviceworkorder.Details, { id: swoVM.id }));
                }
              })
            );
          },
          firstBilling,
          laterBills
        )
      );
    },
    toggleModal: (modalProps: ModalProps) => {
      dispatch(toggleModal(modalProps));
    }
  };
}

// Connect function "wires" both of the map functions and returns a wrapper container for the component
export const ServiceFeePayment = connect(
  mapStateToProps,
  mapDispatchToProps
)(ServiceFeePaymentComponent);



// WEBPACK FOOTER //
// ./src/service-work-order/_components/service-work-order-create/service-fee-payment-step/service-fee-payment.container.ts